import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SpacerVertical } from '@klarna/bubble-ui';
import { Card } from 'moet-core';
import { OnboardingFieldComponent } from '@/bpc/components/OnboardingFieldComponent/OnboardingFieldComponent';
import { ContentAnimationWrapper, LinkWithoutHref } from '@/components';
const groupFieldsByDependencyToApplyAnimations = (fields) => {
    const allFieldPaths = new Set(fields.map(f => f.absolutePath));
    const independentFields = fields
        .filter(f => !f.applicableDependsOn.some(d => allFieldPaths.has(d)))
        .filter(f => f.applicable());
    const dependentFields = fields.filter(f => f.applicableDependsOn.some(d => allFieldPaths.has(d)));
    const regroupedDependentFields = new Set();
    const groupedFields = [{ dependent: false, fields: [] }];
    independentFields.forEach((independendField, i) => {
        groupedFields[groupedFields.length - 1].fields.push(independendField);
        const myDependentFields = dependentFields.filter(d => !regroupedDependentFields.has(d.absolutePath) &&
            d.applicableDependsOn.indexOf(independendField.absolutePath) > -1);
        if (myDependentFields.length > 0) {
            groupedFields.push({ dependent: true, fields: myDependentFields });
            myDependentFields.forEach(d => regroupedDependentFields.add(d.absolutePath));
            if (i !== independentFields.length - 1) {
                groupedFields.push({ dependent: false, fields: [] });
            }
        }
    });
    return groupedFields;
};
export const OnboardingFieldSetComponent = ({ fields, setValueOfField, getValueForField, hasCardLayout, onBlurField, onDelete, t, highlightMandatoryButEmptyFields, }) => {
    const canDelete = onDelete != null;
    const onDeleteClick = (e) => {
        e.preventDefault();
        canDelete && onDelete();
    };
    const onChange = (f) => (v) => setValueOfField(f, v);
    const renderOnboardingFieldComponents = (fields) => fields.map(f => (React.createElement(OnboardingFieldComponent, { key: f.absolutePath, onBlur: onBlurField(f), field: f, onChange: onChange(f), value: getValueForField(f.absolutePath), t: t, highlightMandatoryButEmptyFields: highlightMandatoryButEmptyFields })));
    const renderAnimationWrappedOnboardingFieldComponents = (fields) => [
        React.createElement(ContentAnimationWrapper, { key: fields.map(f => f.absolutePath).join(''), animation: fields.some(f => f.applicable()) ? 'visible' : 'hidden' }, renderOnboardingFieldComponents(fields)),
    ];
    const Wrapper = hasCardLayout
        ? ({ children }) => React.createElement(Card, { hasFooterLink: canDelete }, children)
        : Fragment;
    return (React.createElement(Wrapper, null,
        groupFieldsByDependencyToApplyAnimations(fields).flatMap(g => g.dependent
            ? renderAnimationWrappedOnboardingFieldComponents(g.fields)
            : renderOnboardingFieldComponents(g.fields)),
        React.createElement(SpacerVertical, { small: true }),
        canDelete && (React.createElement("div", { style: { textAlign: 'right' } },
            React.createElement(SpacerVertical, { extraExtraSmall: true }),
            React.createElement(LinkWithoutHref, { onPress: onDeleteClick }, "Remove")))));
};
OnboardingFieldSetComponent.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.object).isRequired,
    getValueForField: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    onBlurField: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
};
